// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YHhg9","toggleWrap":"styles_toggleWrap__20u9D","content":"styles_content__4NXFH","selectAreaCode":"styles_selectAreaCode__29LwM"};